/* global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';

import { AccountActions } from '../actions/account';

import AccountCardsContainer from './AccountCardsContainer';
import { currentUserSelector } from '../reducers/users';

export class OrganizationAccounts extends PureComponent {
  static propTypes = {
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]),
    currentUser: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  render() {
    return <AccountCardsContainer {...this.props} />;
  }
}

const currentOrganizationAccountsSelector = (state, props) => {
  const organizationId = props.params.organizationId;
  const accounts = state.organizations.getIn(
    ['organizations', organizationId, 'accounts'],
    List(),
  );

  return accounts.map(accountId =>
    state.accounts.getIn(['accounts', accountId]),
  );
};

const OrganizationAccountsContainerSelector = immutableCreatorSelector(
  [currentOrganizationAccountsSelector, currentUserSelector],
  (accounts, currentUser) => ({
    accounts,
    currentUser,
  }),
);

@connect(OrganizationAccountsContainerSelector)
export default class OrganizationAccountsContainer extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    params: PropTypes.object,
    currentUser: PropTypes.instanceOf(Map),
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]),
  };

  componentDidMount() {
    const { dispatch, params: { organizationId }, accounts } = this.props;

    if (accounts.size === 0) {
      console.log('organizationId', organizationId);
      dispatch(AccountActions.getAccounts(organizationId));
      // dispatch(AccountActions.getAccountUsers(organizationId));
    }
  }

  render() {
    const { accounts } = this.props;

    if (accounts.size === 0) return <span />;

    return <OrganizationAccounts {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationAccounts.js